import monthlyTicketOrderSaga from './sagas/MonthlyTicketOrderSaga';
import monthlyTicketSettingSaga from './sagas/MonthlyTicketSettingSaga';

export default [
    monthlyTicketOrderSaga,
    monthlyTicketSettingSaga
];